import React from "react";
import { Button } from "carbon-components-react";
import { useNavigate } from "react-router";
import { useFormContext } from "react-hook-form";

const SaveLater = ({ onSave }) => {
  const navigate = useNavigate();
  const { handleSubmit } = useFormContext();

  // "Save and continue later" must NOT submit the enrollment to any systems.
  // Using type="button" keeps it from triggering the form's onSubmit handler
  // (which on the Review step is the final submission). We run handleSubmit so
  // the current page is validated and onSave receives the same yup-cast values
  // the normal submit path would; if the page is invalid, errors are shown and
  // we stay put, matching the original behavior.
  const save = handleSubmit(async (formData) => {
    if (onSave) await onSave(formData);
    navigate("/Saved");
  });

  return (
    <Button type="button" kind="ghost" onClick={save}>
      Save and continue later
    </Button>
  );
};

export default SaveLater;
